$(document).ready(function() {
    // Handle form submission
    $("#thrift-guest-submit").submit(function(event) {
        event.preventDefault();
        handleFormSubmission();
    });

    // Handle form submission when the submit link is clicked
    $('#submitlink').on('click', function(e) {
        e.preventDefault();
        handleFormSubmission();
    });

    // Event delegation to close the modal if the user clicks outside of it
    $(document).on("click", "#successful-submit-modal", function(event) {
        if ($(event.target).is("#successful-submit-modal")) {
            $("#successful-submit-modal").hide();
        }
    });

    // Event delegation to handle modal close button click
    $(document).on("click", "#successful-submit-modal-close-btn", function() {
        $("#successful-submit-modal").hide();
    });
});




// This function checks if the email address is valid
function checkValidEmailAddress(emailAddress) {
    // Regular expression pattern to validate email address
    var pattern = new RegExp(/^(("[\w-+\s]+")|([\w-+]+(?:\.[\w-+]+)*)|("[\w-+\s]+")([\w-+]+(?:\.[\w-+]+)*))(@((?:[\w-+]+\.)*\w[\w-+]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][\d]\.|1[\d]{2}\.|[\d]{1,2}\.))((25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\.){2}(25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\]?$)/i);
    return pattern.test(emailAddress);
}

// This function handles the form submission
function handleFormSubmission() {
    // Retrieve form data
    var subnamevalue = $("#name").val();
    var addressvalue = $("#address").val();
    var phonevalue = $("#phone").val();
    var emailvalue = $("#email").val();
    var websitevalue = $("#website").val();
    var facebookvalue = $("#facebook").val();
    var msgvalue = $("#message").val();
    var usercaptvalue = $("#captchavalue").val();

    // Validate form inputs
    var isValid = true;

    if (!subnamevalue || subnamevalue.length < 3) {
        $("#namelabel").children(".err").fadeIn('slow');
        isValid = false;
    } else {
        $("#namelabel").children(".err").fadeOut('slow');
    }

    if (!addressvalue) {
        $("#addresslabel").children(".err").fadeIn('slow');
        isValid = false;
    } else {
        $("#addresslabel").children(".err").fadeOut('slow');
    }

    if (!phonevalue) {
        $("#phonelabel").children(".err").fadeIn('slow');
        isValid = false;
    } else {
        $("#phonelabel").children(".err").fadeOut('slow');
    }

    if (!checkValidEmailAddress(emailvalue)) {
        $("#emailabel").children(".err").fadeIn('slow');
        isValid = false;
    } else {
        $("#emailabel").children(".err").fadeOut('slow');
    }

    if (!msgvalue || msgvalue.length < 250) {
        $("#msglabel").children(".err").fadeIn('slow');
        isValid = false;
    } else {
        $("#msglabel").children(".err").fadeOut('slow');
    }

    // If form inputs are valid, proceed with form submission
    if (isValid) {
        // Perform AJAX request to check captcha code
        $.ajax({
            type: 'POST',
            url: 'captcha_check.php',
            data: $("#thrift-guest-submit").serialize(),
            success: function(data) {
                if (data == "false") {
                    $("#captchalabel").children(".err").fadeIn('slow');
                } else if (data == "true") {
                    $("#captchalabel").children(".err").fadeOut('slow');

                    // Perform another validation if necessary

                    // If everything is valid, proceed with form submission
                    // Perform AJAX request to submit form data
                    $.ajax({
                        type: 'POST',
                        url: 'thrifter-mailer.php',
                        data: $("#thrift-guest-submit").serialize(),
                        success: function(data) {
                            $("#thrift-guest-submit")[0].reset();
                            document.getElementById('successful-submit-modal').style.display = 'block';
                        }
                    });
                }
            }
        });
    }
}

